import React, { useMemo } from 'react';
import { Popover } from 'antd';
import Sharepop from '../Sharepop/Sharepop';
import { Share, Heart } from '../../assets/icons';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { updatePropertyDetails } from '../../store/reducer/propertyDetailSlice';
import './ShareLike.scss';
import { addOrRemoveToFavouriteAction, updateFavoriteCount } from '../../store/reducer/favoriteSlice';
import { ShareAltOutlined } from '@ant-design/icons'
import { getReferralLink } from '../../services/authApi/authApi';

const ShareLike = (props) => {
  const { showFavourite = true, isHeader = false } = props;
  const { data } = useSelector((state) => state.propertyDetails);
  const userProfileData = useSelector((state) => state.userData.userData);
  const navigate = useNavigate();
  const { propertyId } = useParams();
  const dispatch = useDispatch();
  // TODO : Create SHARE LINKS and change it from props to generated based on location
  const favorite = useMemo(() => {
    return Boolean(data?.data?.isFavourite);
  }, [data?.data?.isFavourite]);

  const onFavouriteFail = () => {
    const newData = {
      ...data,
      data: {
        ...data?.data,
        isFavourite: favorite,
      },
    };
    dispatch(updatePropertyDetails({ ...newData }));
  };
  const handleOnPopoverClick = async () => {
    try {
      let link = localStorage.getItem('referralLink');
      if(!link) {
        const token = localStorage.getItem('access_token');
        link = await getReferralLink(token);
        localStorage.setItem('referralLink', link.data.referralLink);
      }
    } catch (error) {
      // Handle error
      console.error('Error fetching referral link:', error);
    }
  };
  const handleOnFavoriteClick = () => {
    if (Object.keys(userProfileData).length) {
      const newData = {
        ...data,
        data: {
          ...data?.data,
          isFavourite: !favorite,
        },
      };
      dispatch(updatePropertyDetails({ ...newData }));
      dispatch(addOrRemoveToFavouriteAction({ propertyId, onFail: onFavouriteFail }));
      if (!favorite) {
        dispatch(updateFavoriteCount());
      }
    } else {
      navigate('/login');
    }
  };

  const { twitterLink = 'https://twitter.com', facebookLink = 'https://facebook.com', linkedinLink = 'https://linkedin.com' } = props;
  return (
    <div className={`${props.className ? props.className : ''} d-flex g-24 text-terracotta share-like`}>
      <div id='share-link' />
      <Popover
        placement='bottom'
        overlayClassName='sharepop-wrapper'
        getPopupContainer={() => document.getElementById('share-link')}
        content={<Sharepop twitterLink={twitterLink} facebookLink={facebookLink} linkedinLink={linkedinLink} isHeader={isHeader} />}
        trigger='click'
        onOpenChange={handleOnPopoverClick}
      >
        {isHeader ? <ShareAltOutlined className='fz-24 text-almost-black' size={24} /> :
          <div className='d-flex g-8 share'>
            <Share className='cursor-pointer d-sm' size={24} />
            <span className='cursor-pointer d-md fw-600'>Share</span>
          </div>
        }
      </Popover>
      {showFavourite && <div className='d-flex g-8 like' onClick={() => handleOnFavoriteClick(favorite)}>
        <Heart className='cursor-pointer' size={24} fill={favorite ? '#8A4743' : 'none'} />
        <span className='cursor-pointer d-md fw-600'>Favorite</span>
      </div>}
    </div>
  );
};

export default ShareLike;
